import { PropsWithChildren, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ROOT_PATHS } from '../../router/routes'
import { useAppDispatch, useAppSelector } from '../../store'
import { getRegistrationInfo } from '../../store/actions/registration'
import { useAPIData } from '../../store/axiosConfiguration'
import { USER_STATUS } from '../../store/type/users'

type SignRouterContainerProps = {}

const SignRouterContainer: React.FC<PropsWithChildren<SignRouterContainerProps>> = ({ children }) => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { t } = useTranslation('general')
  const { info: userInfo } = useAppSelector((state) => state.registration)
  const [hasValidState, setHasValidState] = useState<boolean>(false)
  const [message, setMessage] = useState<{ severity: 'info' | 'error'; message: string }>()

  useEffect(() => {
    dispatch(getRegistrationInfo())
  }, [dispatch, t])

  useEffect(() => {
    const selectedLanguage = localStorage.getItem('selectedLanguage');

    if ( selectedLanguage ) {
      i18n.changeLanguage(selectedLanguage);
    } 
  }, [i18n])


  useAPIData(
    userInfo,
    useMemo(
      () => ({
        onFulfilled: (data) => {
          switch (data.userStatus) {
            case USER_STATUS.CREATED:
              setMessage(undefined)
              setHasValidState(true)
              break
            case USER_STATUS.INVITED:
            case USER_STATUS.NEW_USER:
              navigate(ROOT_PATHS.REGISTRATION)
              setHasValidState(true)
              break

            case USER_STATUS.REGISTERED:
              navigate(ROOT_PATHS.WAITING_CONF)
              setHasValidState(true)
              break

            default:
              setMessage({
                severity: 'error',
                message: t('title.not_recognized'),
              })

              console.warn('User status not recognized')
              break
          }
        },
        onRejected: () => {
          setMessage({
            severity: 'error',
            message: t('title.no_info'),
          })
        },
      }),
      [navigate, t],
    ),
  )

  if ( !message && !hasValidState ) {
    return null;
  }

  return hasValidState ? (
    <>{children}</>
  ) : (
    <div className={`alert-message ${message?.severity}`}>{message?.message}</div>
  )
}

export default SignRouterContainer
